import React, { FC } from 'react';
import { DateVOv2 } from '../../../../core/DateVOv2';

interface CopyrightProp {
  lang: string;
}

export const Copyright: FC<CopyrightProp> = ({ lang }) => {
  const currentYear = new DateVOv2().getCurrentYear();

  return (
    <div className="copyright">
      <p>
        Copyright © {currentYear}{' '}
        <a href={`https://www.briz.ua/${lang === 'ua' ? '' : lang}`} target="_blank" rel="noreferrer">
          BRIZ.
        </a>{' '}
        All rights reserved.
      </p>
    </div>
  );
};
